module.exports = __webpack_public_path__ + "img/arrow.bd184b99.png";